/** @format */

import { configureStore } from '@reduxjs/toolkit'
import globalDataSlice from './globalDataSlice'
// configureStore创建一个redux数据
const store = configureStore({
  reducer: {
    globalData: globalDataSlice
  },
  devTools: true
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
